<script>
import { sumBy } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'productList',
  props: ['value'],
  data() {
    return {
      loading: false,
      products: [],
      params: {
        search: ''
      }
    }
  },
  computed: {
    allowAddProduct: vm => products => {
      const soldOutOfProduction =
        vm.$store.state.authUser.sys_setting.is_allow_sale_without_stock
      if (soldOutOfProduction) return true

      return products.is_calculate_stock
        ? vm.currentStock(products.product_id) > 0
        : true
    },
    currentStock: vm => productId => {
      const proList = vm.products.find(p => p.product_id == productId)
      let productItem = sumBy(
        vm.value.product_detail.filter(p => p.product_id == productId),
        'quantity'
      )
      return proList.ending_balance - productItem
    }
  },
  methods: {
    ...mapActions('saleInvoiceStore', ['onGetProduct']),
    async fetchProduct() {
      this.loading = true
      const product = await this.onGetProduct({ params: this.params })
      this.loading = false
      this.products = product.data
    },
    onSelectedProduct(product) {
      this.$emit('selectedProduct', product)
    }
  }
}
</script>

<template>
  <div>
    <ts-loading-banner :loading="loading">
      <table class="ts-w-full ts-mt-4">
        <thead>
          <tr>
            <th
              class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-px-2 ts-py-1 ts-w-32"
            >
              {{ $t('saleInvoice.gorup') }}
            </th>
            <th
              class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-px-2 ts-py-1 ts-w-20"
            >
              {{ $t('saleInvoice.barcode') }}
            </th>
            <th
              class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-px-2 ts-py-1"
            >
              {{ $t('saleInvoice.productName') }}
            </th>
            <th
              class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-px-2 ts-py-1 ts-w-10 ts-whitespace-no-wrap"
            >
              {{ $t('saleInvoice.currentStock') }}
            </th>
            <th
              class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-px-2 ts-py-1 ts-w-8"
            >
              {{ $t('saleInvoice.quantity') }}
            </th>
            <th
              class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-px-2 ts-py-1 ts-w-8"
            >
              {{ $t('actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(p, index) in products"
            :key="index"
            :class="{ 'ts-bg-gray-100': index % 2 !== 0 }"
            class="hover:ts-bg-gray-300 ts-duration-150 ts-transform ts-transition-all ts-cursor-pointer"
          >
            <td class="ts-px-2 ts-py-1">{{ p.pro_group_name_en }}</td>
            <td class="ts-px-2 ts-py-1">{{ p.barcode }}</td>
            <td class="ts-px-2 ts-py-1">{{ p.product_name_en }}</td>
            <td class="ts-px-2 ts-py-1 ts-text-center">
              {{ p.ending_balance }}
            </td>
            <td class="ts-px-2 ts-py-1">
              <input
                type="number"
                class="ts-outline-none ts-w-10 ts-text-center"
                placeholder="Qty"
                v-model="p.qty"
              />
            </td>
            <td class="ts-px-2 ts-py-1 ts-text-center">
              <a
                v-if="allowAddProduct(p)"
                href="#"
                v-tooltip="$t('add')"
                class="ts-mb-0"
                @click.prevent="onSelectedProduct(p)"
              >
                <i class="fa fa-plus"></i>
              </a>
            </td>
          </tr>
          <tr v-if="!products.length">
            <td colspan="6" hieght="30" class="ts-text-center">
              <br /><br />
              <i class="fas fa-folder-open fa-2x"></i>
              <h5 class="ts-text-gray-400">{{ $t('noData') }}</h5>
            </td>
          </tr>
        </tbody>
      </table>
    </ts-loading-banner>
  </div>
</template>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  background: transparent;
}
</style>
